import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, map } from 'rxjs/operators';
import * as crmActions from '../../actions/crm/crm.actions';
import { CRMService } from 'src/app/services/crm/crm.service';

@Injectable()
export class CRMEffects {
  store: any;

  constructor(
    private actions$: Actions,
    private crmService: CRMService
  ) {}

  getCrmOffers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(crmActions.getCRMOffersApi),
      exhaustMap(() =>
        this.crmService.getCRMOffers().pipe(
          map((resp: HttpResponse<any>) => {
            let crmBody = {
              careForCustomer: resp.body?.careForCustomer,
              nextBestOffer: resp.body?.nextBestOffer,
              salesCampaign: resp.body?.salesCampaign,
              countMessages: resp.body?.countMessages
            }
            return crmActions.getCRMOffersSuccess({
              offers: crmBody ? crmBody : null
            });
          })
        )
      )
    );
  });
}
